<template>
    <div class="bio-payout-container">
        <div class="bio">
            <p class="title">Bio</p>
            <div class="textarea">
                <span
                    class="counter"
                    :class="
                        $v.userData.bioPayout.long_biography.$dirty &&
                        !$v.userData.bioPayout.long_biography.maxLength
                            ? 'error'
                            : ''
                    "
                >
                    {{ `${userData.bioPayout.long_biography.length} / 500` }}
                </span>
                <textarea
                    name="long_biography"
                    v-model="$v.userData.bioPayout.long_biography.$model"
                    placeholder="Describe the details: audience, vibe, character of your venue"
                ></textarea>
            </div>
        </div>
        <div class="payout">
            <p class="title">Desired Payout</p>
            <p class="desc">
                This amount will be shown on your profile. You can always make an offer at a
                different rate to secure a booking.
            </p>
            <div class="min-payout-input">
                <label for="min_payout">Min *</label>
                <input
                    type="number"
                    name="min_payout"
                    v-model="$v.userData.bioPayout.min_payout.$model"
                    placeholder="Eg. $100"
                />
                <span
                    v-if="
                        $v.userData.bioPayout.min_payout.$dirty &&
                        $v.userData.bioPayout.min_payout.$model
                    "
                    class="dollar-sign"
                >
                    $
                </span>
                <span
                    class="error-msg"
                    v-if="
                        $v.userData.bioPayout.min_payout.$dirty &&
                        !$v.userData.bioPayout.min_payout.minValue
                    "
                >
                    Please enter more than 1 dollar.
                </span>
            </div>
        </div>
    </div>
</template>
<script>
    import { required, minValue, maxLength } from 'vuelidate/lib/validators'

    export default {
        name: 'BioPayout',
        props: {
            userData: {
                type: Object,
                required: true
            },
            validation: {
                type: Object,
                required: false
            }
        },
        watch: {
            $v: {
                handler: function (validation) {
                    this.$emit('update:validation', validation)
                },
                immediate: true
            }
        },
        validations: {
            userData: {
                bioPayout: {
                    long_biography: {
                        maxLength: maxLength(500)
                    },
                    min_payout: {
                        required,
                        minValue: minValue(1)
                    }
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .bio-payout-container {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 40px;

        .title {
            color: #dedede;
            @include base-font-24;
            font-weight: 600;
            line-height: 28px;
        }
        .error-msg {
            color: #ed3c0d;
            font-family: Instrument Sans;
            font-size: 8px;
            font-style: normal;
            font-weight: 600;
            line-height: 130%;
            letter-spacing: 0.14px;
        }

        .bio {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 8px;

            .textarea {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                justify-content: flex-start;

                .counter {
                    color: #646464;
                    text-align: right;
                    @include base-font-12;
                    line-height: 135%;
                    letter-spacing: 0.12px;
                }
                .error {
                    color: #ed3c0d;
                }

                textarea {
                    width: 100%;
                    height: 184px;
                    padding: 10px 12px;
                    border-radius: 8px;
                    border: 1px solid #8b8b8b;
                    background: inherit;
                    resize: none;
                    color: #dedede;
                    @include base-font-16;
                    line-height: 125%;
                }
                textarea::placeholder {
                    overflow: hidden;
                    color: #646464;
                    text-overflow: ellipsis;
                    @include base-font-16;
                    line-height: 125%;
                }
            }
        }
        .payout {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 8px;

            .desc {
                color: #8b8b8b;
                @include base-font-16;
                font-weight: 400;
                line-height: 24px;
                text-wrap: wrap;
            }
            .min-payout-input {
                position: relative;
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;

                .dollar-sign {
                    position: absolute;
                    left: 7px;
                    top: 34px;
                    color: #dedede;
                    text-overflow: ellipsis;
                    @include base-font-16;
                    line-height: 125%;
                }

                label {
                    padding: 4px 2px;
                    color: #8b8b8b;
                    @include base-font-12;
                    line-height: 135%;
                    letter-spacing: 0.12px;
                }
                input {
                    width: 100%;
                    height: 40px;
                    padding: 10px 12px;
                    border-radius: 8px;
                    border: 1px solid #8b8b8b;
                    background: inherit;
                    color: #dedede;
                    @include base-font-16;
                    line-height: 125%;
                    -moz-appearance: textfield;
                    appearance: textfield;
                    padding-left: 20px;
                }
                input::-webkit-outer-spin-button,
                input::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
                input::placeholder {
                    overflow: hidden;
                    color: #646464;
                    text-overflow: ellipsis;
                    @include base-font-16;
                    line-height: 125%;
                }
            }
        }
    }
</style>
